<template>
    <div class="titular-wrapper" :titularn="numTitular"> 
        <p class="titular-title">Titular {{ numTitular + 1 }}</p>   
        <div class="titular-content">          
            <InputField 
                inputType = "number" 
                placeholder = "Edad"
                label = "Edad"
                :isRequired = "true"
                :currentValue = "$store.state.prescoringData.titulares[numTitular].edad"
                @valueChanged = "(value) => handleTitularValueChange('edad', value)" /> 
            <InputSelect
                :options = "$store.state.inputOptionsVariables.tipo_contrato"
                placeholder = "Tipo de contrato"
                :selected = "$store.state.prescoringData.titulares[numTitular].contrato"
                @valueChanged = "(value) => handleTitularValueChange('contrato', value)" />
            <InputField 
                inputType = "number" 
                placeholder = "Antigüedad contrato (meses)" 
                label = "Antigüedad contrato (meses)"
                :isRequired = "true"
                :max_value = "720"
                :currentValue = "$store.state.prescoringData.titulares[numTitular].antiguedad"
                @valueChanged = "(value) => handleTitularValueChange('antiguedad', value)" />
        </div>
    </div> 
</template>

<script>
import InputField from './InputField.vue'
import InputSelect from './InputSelect.vue'

export default {
    name: 'TitularComponent',
    components: {
        InputField,
        InputSelect
    },
    props: {
        numTitular: {
            type: Number,
            required: true,
            default: 0
        }
    },
    methods: {
        handleTitularValueChange(field, value){
            this.$store.commit('updateTitularField', {titularIndex: this.numTitular, field: field, value: value });
        }
    }
}
</script>

<style>
    .titular-title{
        display: block;
        margin-bottom: 10px;
    }
    .titular-content{
        display: flex;
        gap: 8px;
    }
    /* MOVIL */
    @media (max-width: 768px) {
        .titular-content{
            display: flex;
            flex-direction: column;
            gap: 10px;
        }
    }
    /* TABLET */
    @media (min-width: 769px) and (max-width: 992px) {
        .titular-wrapper {
            width: 100%;
        }
        .titular-content > *:first-child {
            flex: 0 0 90px; 
        }
        .titular-content > *:nth-child(2),
        .titular-content > *:nth-child(3) {
            flex: 1; 
        }
    }
    /* ESCRITORIO*/
    @media (min-width: 993px) {
        .titular-content > *:first-child {
            flex: 0 0 70px; /* Ancho fijo para el primer elemento */
        }
        .titular-content > *:nth-child(2),
        .titular-content > *:nth-child(3) {
            flex: 1; /* Repartir el espacio restante equitativamente */
        }
    }

</style>